import React from "react";
import { STATUS_META, closedReasonLabel, nameOf,
         UNRECOGNISED_WORD } from "@/lib/format";
import * as Icons from "@phosphor-icons/react";

// `expense`: the row itself, when the chip should say why it closed.
export function StatusChip({ status, expense, full = false, size = 14 }) {
  // A STATUS THIS CHIP DOES NOT KNOW USED TO BE PRINTED AS ITSELF, label and
  // short alike — and unlike the rest of ZEN-635 this one was REACHING FAMILIES:
  // an expense split into parts reads `split`, and Money Trace lists split
  // originals. STATUS_META names that word now; this is what is left for a word
  // it does not have.
  //
  // The expense status SET is still not declared or parity-checked against the
  // server the way the other three are — it is read in many places and belongs
  // with ZEN-336. What is closed here is that none of it can reach a family raw.
  const m = nameOf(STATUS_META, status, {
    label: UNRECOGNISED_WORD, short: UNRECOGNISED_WORD,
    bg: "#6B7280", fg: "#fff", icon: "Circle",
  });
  const Icon = Icons[m.icon] || Icons.Circle;
  const reasonLabel = expense ? closedReasonLabel({ ...expense, status }) : null;
  return (
    <span className="inline-flex flex-col items-start">
      <span
        data-testid={`status-chip-${status}`}
        className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
        style={{ background: m.bg, color: m.fg }}
      >
        <Icon size={size} weight="fill" aria-hidden="true" />
        {full ? m.label : m.short}
      </span>
      {reasonLabel && (
        <span data-testid="closed-reason" className="mt-0.5 pl-1 text-[10px] text-[#6B7280]">{reasonLabel}</span>
      )}
    </span>
  );
}
